/*
 * Общая таблица ресурсов на главной: заголовок с иконкой и ссылкой «все …», колонки,
 * строки из useResources, заглушка при пустом каталоге, при необходимости пагинация.
 */
import { ReactNode } from 'react';
import {
  ResponseErrorPanel,
  Table,
  TableColumn,
} from '@backstage/core-components';
import { Button } from '@material-ui/core';
import { CardTitle } from './CardTitle';
import { EmptyRows } from './EmptyRows';

export type ResourceCardProps<T extends object> = {
  icon: ReactNode;
  title: string;
  to: string;
  linkText: string;
  columns: TableColumn<T>[];
  rows?: T[];
  loading: boolean;
  error?: Error;
  errorTitle: string;
  emptyText: string;
  createText: string;
  createTo: string;
  /** Размер страницы; без него пагинации нет. */
  pageSize?: number;
};

export function ResourceCard<T extends object>({
  icon,
  title,
  to,
  linkText,
  columns,
  rows,
  loading,
  error,
  errorTitle,
  emptyText,
  createText,
  createTo,
  pageSize,
}: ResourceCardProps<T>) {
  if (error) {
    return <ResponseErrorPanel title={errorTitle} error={error} />;
  }
  const data = rows ?? [];
  const paging = Boolean(pageSize) && data.length > (pageSize ?? 0);
  return (
    <Table<T>
      title={<CardTitle icon={icon} text={title} to={to} linkText={linkText} />}
      columns={columns}
      data={data}
      isLoading={loading}
      options={{
        paging,
        pageSize,
        pageSizeOptions: pageSize ? [pageSize, pageSize * 2, pageSize * 4] : [],
        emptyRowsWhenPaging: false,
        search: false,
        padding: 'dense',
        draggable: false,
      }}
      emptyContent={
        <EmptyRows
          text={emptyText}
          action={
            <Button color="primary" href={createTo}>
              {createText}
            </Button>
          }
        />
      }
    />
  );
}
